"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.answerValues = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _radioGroupStandard = _interopRequireDefault(require("../../components/radioGroupStandard"));

var _lodash = _interopRequireDefault(require("lodash"));

var _useTranslated = require("../../hooks/useTranslated");

var _excluded = ["selected_language", "input"];

/**
 * @desc International Language (standard component) answer values
 *
 * @type {{[key: string]: string}}
 */
var answerValues = {
  yes: 'yes',
  no: 'no'
};
exports.answerValues = answerValues;

var LanguageIntl = function LanguageIntl(_ref) {
  var _ref$selected_languag = _ref.selected_language,
      selected_language = _ref$selected_languag === void 0 ? 'English' : _ref$selected_languag,
      input = _ref.input,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var selectedLanguage = (0, _useTranslated.useTranslated)("common.languages.".concat(selected_language));
  var label = (0, _useTranslated.useTranslated)('fields.languageIntl.label', {
    language: selectedLanguage
  });
  var answers = [{
    label: (0, _useTranslated.useTranslated)('common.yes'),
    value: 'yes'
  }, {
    label: (0, _useTranslated.useTranslated)('common.no'),
    value: 'no'
  }];
  return /*#__PURE__*/_react["default"].createElement(_radioGroupStandard["default"], (0, _extends2["default"])({}, props, input, {
    label: label,
    answers: answers
  }));
};

LanguageIntl.propTypes = {
  name: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func.isRequired
};
var _default = LanguageIntl;
exports["default"] = _default;